import { SelectItem } from '@/components/ui/select';
import { SelectField } from './SelectField';
import { useNode } from '@craftjs/core';
import { useFonts } from '@/context/FontProvider';
import { editorRegistry } from '@/components/userComponents/Text';
import { cn } from '@/lib/utils';
import { applyMark } from '@/utils/textUtils';
import { Editor as SlateEditor } from 'slate';
import type { ButtonProps } from '@builder4/shared/components/Button';
import { isTextBlockNode } from '@/utils/helperFunc';

const NodeFontFamilySettings = ({
  onSelect,
  className = 'max-w-[216px]',
}: {
  onSelect?: (fontFamily: string) => void;
  className?: string;
}) => {
  const { fonts } = useFonts();
  const {
    id,
    props,
    node,
    actions: { setProp },
  } = useNode((node) => ({
    node: node,
    id: node.id,
    props: node.data.props,
  }));
  const handleFontChange = (family: string) => {
    onSelect?.(family);

    if (isTextBlockNode(node)) {
      const slateEditor = editorRegistry.get(id);
      if (!slateEditor) return;
      const { editor } = slateEditor;

      applyMark(editor, 'fontWeight', '400');
      applyMark(editor, 'fontFamily', family);
    } else {
      setProp((props: Partial<ButtonProps>) => {
        props.fontFamily = family;
        props.fontWeight = '400';
      });
    }
  };

  const getFontFamily = () => {
    if (isTextBlockNode(node)) {
      const slateEditor = editorRegistry.get(id);
      if (!slateEditor) return 'Inter';
      const { editor } = slateEditor;
      const marks = SlateEditor.marks(editor) as React.CSSProperties;
      const FinalFontFamily =
        marks != undefined && Object.keys(marks)?.length > 0 && marks['fontFamily'] != undefined
          ? marks['fontFamily']
          : 'Inter';
      return FinalFontFamily;
    } else {
      return props.fontFamily || 'Inter';
    }
  };

  return (
    <>
      <SelectField
        onValueChange={handleFontChange}
        className={cn(className)}
        defaultValue={getFontFamily()}
        size="small"
        text="Font"
        dataTestId="font-selection"
      >
        {fonts.length > 0 ? (
          fonts.map((font) => (
            <SelectItem
              key={font.family}
              value={font.family}
              style={{
                fontFamily: font.family,
                fontSize: '14px',
                fontWeight: '400',
              }}
            >
              {font.family}
            </SelectItem>
          ))
        ) : (
          <SelectItem value="loading" disabled>
            Loading fonts...
          </SelectItem>
        )}
      </SelectField>
    </>
  );
};

export default NodeFontFamilySettings;
